import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { AuthenticateService } from 'app/services/authenticate.service';
import { FormsModule } from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { UniversidadComponent } from './universidad/universidad.component';
import { MessagesComponent } from './messages/messages.component';
import { MessageService } from 'app/services/message.service';

@NgModule({
  imports: [
    CommonModule, FormsModule, HttpModule, HttpClientModule
  ],
  declarations: [LoginComponent, UniversidadComponent, MessagesComponent],
  providers: [AuthenticateService,MessageService]
})
export class LoginModule { }



// WEBPACK FOOTER //
// /app/src/app/modules/login/login.module.ts